/* Wendle · Nimbao-reference layer: navigation, product offers (1 / Buy 1 Get 1), accessory rows,
   variant pickers in the cart, order tracking. Self-contained; reads routes/money format from window.Wendle. */
(() => {
  'use strict';
  const W = window.Wendle || (window.Wendle = {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  /* ---------- Shared helpers (self-contained; wendle.js keeps its own copies) ---------- */
  const money = (cents) => {
    const fmt = W.moneyFormat || '£{{amount}}';
    const v = cents / 100;
    const d = (n, dec, t, p) => { const x = n.toFixed(dec).split('.'); x[0] = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return x.join(p); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k === 'amount_no_decimals' ? d(v, 0, ',', '.') : k === 'amount_with_comma_separator' ? d(v, 2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? d(v, 0, '.', ',') : d(v, 2, ',', '.')));
  };
  let toastT;
  const toast = (m) => { const el = document.getElementById('Toast'); if (!el) return; el.textContent = m; el.hidden = false; clearTimeout(toastT); toastT = setTimeout(() => { el.hidden = true; }, 3200); };
  const setCount = (n) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; if (el.classList.contains('cart-bubble')) { el.classList.toggle('is-empty', n === 0); el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); } });
    $$('.header__cart').forEach((a) => a.setAttribute('aria-label', `Cart, ${n} items`));
  };
  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      const cur = document.querySelector(`[data-cart-root][data-section="${id}"]`);
      if (!cur || !html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
      if (!fresh) return;
      if (cur.classList.contains('drawer')) { const a = cur.querySelector('.drawer__panel'), b = fresh.querySelector('.drawer__panel'); if (a && b) a.innerHTML = b.innerHTML; }
      else cur.innerHTML = fresh.innerHTML;
    });
  };
  const addToCart = async (items) => {
    const ids = $$('[data-cart-root]').map((el) => el.dataset.section).filter(Boolean);
    const res = await fetch(`${(W.routes && W.routes.cartAdd) || '/cart/add'}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: ids.join(','), sections_url: location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    renderSections(data.sections);
    try { const c = await (await fetch(`${(W.routes && W.routes.cart) || '/cart'}.js`)).json(); setCount(c.item_count); } catch (e) { /* ignore */ }
    return data;
  };
  const openCart = () => { const o = document.querySelector('.header__cart[data-cart-open]'); if (o && document.getElementById('CartDrawer') && W.cartType === 'drawer') o.click(); else location.href = (W.routes && W.routes.cart) || '/cart'; };
  W.nAddToCart = addToCart;

  /* ---------- Header dropdowns ---------- */
  const closeAll = () => $$('.n-nav__item.is-open').forEach((li) => { li.classList.remove('is-open'); const b = $('[data-n-nav-toggle]', li); if (b) b.setAttribute('aria-expanded', 'false'); });
  $$('[data-n-nav-toggle]').forEach((btn) => {
    const li = btn.closest('.n-nav__item');
    let t;
    const open = () => { clearTimeout(t); closeAll(); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    btn.addEventListener('click', (e) => { e.stopPropagation(); li.classList.contains('is-open') ? closeAll() : open(); });
    if (matchMedia('(hover: hover)').matches) {
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', () => { t = setTimeout(closeAll, 160); });
    }
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.n-nav__item')) closeAll(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Country selector ---------- */
  $$('[data-n-autosubmit]').forEach((sel) => sel.addEventListener('change', () => sel.form && sel.form.submit()));

  /* ---------- Variant helpers ---------- */
  const findVariant = (variants, opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

  /* ---------- Product page ---------- */
  $$('[data-n-product]').forEach((root) => {
    const jsonEl = $('[data-n-product-json]', root);
    if (!jsonEl) return;
    const P = JSON.parse(jsonEl.textContent);
    const form = $('[data-n-form]', root);
    const atc = $('[data-n-atc]', root);
    const atcLabel = $('[data-n-atc-label]', root);
    const errEl = $('[data-n-error]', root);
    const cards = $$('[data-n-bundle]', root);
    const baseLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

    /* Gallery */
    const slides = $$('.n-gallery__slide', root);
    const thumbs = $$('[data-n-thumb]', root);
    let gi = 0;
    const show = (i) => {
      if (!slides.length) return;
      gi = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === gi));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === gi));
      const th = thumbs[gi];
      if (th && th.parentElement) th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
    };
    const showMedia = (id) => { const i = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (i > -1) show(i); };
    const showColour = (colour) => {
      if (!colour) return;
      const v = P.variants.find((x) => x.options[P.colourIndex] === colour && x.media);
      if (v) { showMedia(v.media); return; }
      const i = slides.findIndex((s) => (s.dataset.alt || '').toLowerCase() === colour.toLowerCase());
      if (i > -1) show(i);
    };
    thumbs.forEach((t, n) => t.addEventListener('click', () => show(n)));
    const prev = $('[data-n-gal-prev]', root), next = $('[data-n-gal-next]', root);
    if (prev) prev.addEventListener('click', () => show(gi - 1));
    if (next) next.addEventListener('click', () => show(gi + 1));
    // swipe on the main image
    const main = $('.n-gallery__main', root);
    if (main) {
      let x0 = null;
      main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1)); x0 = null; });
    }

    /* Rows (#1 / #2) */
    const rowState = (row) => {
      const sel = $$('[data-n-opt]', row).sort((a, b) => a.dataset.nOpt - b.dataset.nOpt).map((s) => s.value || null);
      if (P.single) return { variant: P.variants[0], sel: [] };
      const complete = sel.every(Boolean);
      return { variant: complete ? findVariant(P.variants, sel) : null, sel, complete };
    };
    const paintRow = (row) => {
      if (P.single) return;
      const selects = $$('[data-n-opt]', row);
      const sel = rowState(row).sel;
      selects.forEach((s) => {
        const idx = parseInt(s.dataset.nOpt, 10);
        $$('option', s).forEach((o) => {
          if (!o.value) return;
          const test = sel.slice(); test[idx] = o.value;
          const cands = P.variants.filter((v) => v.options.every((ov, i) => (i === idx ? ov === o.value : (test[i] == null || ov === test[i]))));
          const exists = cands.length > 0;
          const avail = cands.some((v) => v.available);
          const base = o.dataset.label || o.textContent.replace(/ – (sold out|unavailable)$/, '');
          o.dataset.label = base;
          if (idx === P.colourIndex) { o.textContent = base; o.disabled = false; return; }
          o.textContent = base + (!exists ? ' – unavailable' : !avail ? ' – sold out' : '');
          o.disabled = !exists || !avail;
        });
      });
      // colour thumbnail
      const thumb = $('[data-n-thumbimg]', row);
      if (thumb && P.colourIndex > -1) {
        const colour = sel[P.colourIndex];
        const v = P.variants.find((x) => x.options[P.colourIndex] === colour && x.img);
        if (v) thumb.innerHTML = `<img src="${v.img}" alt="" width="60" height="60" loading="lazy">`;
      }
    };

    const activeCard = () => cards.find((c) => c.classList.contains('is-selected')) || cards[0];
    const priceFor = (variant) => (variant ? variant.price : (P.variants.find((v) => v.available) || P.variants[0]).price);

    const updatePrices = () => {
      const c1 = cards.find((c) => c.dataset.nBundle === '1');
      const c2 = cards.find((c) => c.dataset.nBundle === '2');
      if (c1) {
        const v = rowState($('[data-n-row]', c1) || c1).variant;
        const el = $('[data-n-price-one]', c1); if (el) el.textContent = money(priceFor(v));
      }
      if (c2) {
        const rows = $$('[data-n-row]', c2);
        const prices = rows.map((r) => priceFor(rowState(r).variant));
        if (!prices.length) prices.push(priceFor(null), priceFor(null));
        const sum = prices.reduce((a, b) => a + b, 0);
        const max = Math.max(...prices);
        const two = $('[data-n-price-two]', c2), cmp = $('[data-n-compare-two]', c2), each = $('[data-n-each]', c2);
        if (P.bogo) {
          if (two) two.textContent = money(max);
          if (cmp) cmp.textContent = money(sum);
          if (each) each.textContent = money(Math.round(max / 2));
        } else if (two) two.textContent = money(sum);
      }
    };

    const updateButton = () => {
      const card = activeCard();
      const rows = card ? $$('[data-n-row]', card) : [];
      const states = rows.map(rowState);
      if (P.single) { atc.disabled = !P.variants[0].available; atcLabel.textContent = P.variants[0].available ? baseLabel : 'Sold out'; return; }
      const missing = states.some((s) => !s.complete);
      const bad = states.find((s) => s.complete && (!s.variant || !s.variant.available));
      atc.disabled = false;
      if (bad) { atcLabel.textContent = bad.variant ? 'Sold out' : 'Unavailable'; atc.disabled = true; }
      else if (missing) atcLabel.textContent = P.sizeIndex > -1 ? 'Choose your size' : 'Choose an option';
      else atcLabel.textContent = baseLabel;
    };

    const refresh = () => { $$('[data-n-row]', root).forEach(paintRow); updatePrices(); updateButton(); };

    root.addEventListener('change', (e) => {
      const radio = e.target.closest('[data-n-bundle-radio]');
      if (radio) {
        cards.forEach((c) => {
          const on = c.contains(radio);
          c.classList.toggle('is-selected', on);
          const body = $('[data-n-bundle-body]', c);
          if (body) body.hidden = !on;
        });
        // carry the choice of row #1 over to the newly opened card
        const from = cards.find((c) => !c.classList.contains('is-selected'));
        const to = activeCard();
        if (from && to) {
          const a = $('[data-n-row="1"]', from), b = $('[data-n-row="1"]', to);
          if (a && b) $$('[data-n-opt]', a).forEach((s) => { const t = $(`[data-n-opt="${s.dataset.nOpt}"]`, b); if (t && s.value) t.value = s.value; });
          const b2 = $('[data-n-row="2"]', to);
          if (a && b2) $$('[data-n-opt]', a).forEach((s) => { const t = $(`[data-n-opt="${s.dataset.nOpt}"]`, b2); if (t && s.value && !t.value) t.value = s.value; });
        }
        if (errEl) errEl.hidden = true;
        refresh();
        return;
      }
      const sel = e.target.closest('[data-n-opt]');
      if (sel) {
        const row = sel.closest('[data-n-row]');
        if (parseInt(sel.dataset.nOpt, 10) === P.colourIndex && row) showColour(sel.value);
        sel.classList.remove('is-error');
        if (errEl) errEl.hidden = true;
        refresh();
      }
    });

    const showError = (msg, el) => {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      if (el) { el.classList.remove('is-error'); void el.offsetWidth; el.classList.add('is-error'); el.focus({ preventScroll: true }); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const card = activeCard();
      const rows = P.single ? [] : $$('[data-n-row]', card);
      const items = [];
      if (P.single) {
        items.push({ id: P.variants[0].id, quantity: card.dataset.nBundle === '2' ? 2 : 1 });
      } else {
        for (const row of rows) {
          const st = rowState(row);
          const n = row.dataset.nRow;
          if (!st.complete) {
            const empty = $$('[data-n-opt]', row).find((s) => !s.value);
            showError(rows.length > 1 ? `Please choose a ${P.sizeIndex > -1 ? 'size' : 'option'} for item #${n}.` : `Please choose your ${P.sizeIndex > -1 ? 'size' : 'option'}.`, empty);
            return;
          }
          if (!st.variant) { showError(`Item #${n}: this combination is not available.`); return; }
          if (!st.variant.available) { showError(`Item #${n}: this combination is sold out.`); return; }
          const same = items.find((it) => it.id === st.variant.id);
          if (same) same.quantity += 1; else items.push({ id: st.variant.id, quantity: 1 });
        }
      }
      atc.classList.add('is-loading'); atc.disabled = true;
      try {
        await addToCart(items);
        openCart();
      } catch (err) {
        showError(err.message || 'Something went wrong. Please try again.');
      } finally {
        atc.classList.remove('is-loading'); atc.disabled = false; updateButton();
      }
    });

    // keep the preselected colour and the first image in step
    if (!P.single && P.colourIndex > -1 && slides.length) {
      const firstId = slides[0].dataset.mediaId;
      const match = P.variants.find((x) => String(x.media) === String(firstId));
      const colourSelects = $$(`[data-n-opt="${P.colourIndex}"]`, root);
      if (match) {
        const c = match.options[P.colourIndex];
        colourSelects.forEach((s) => { if ([...s.options].some((o) => o.value === c)) s.value = c; });
      } else if (colourSelects[0] && colourSelects[0].value) {
        showColour(colourSelects[0].value);
      }
    }
    refresh();
  });

  /* ---------- Accessory rows on the product page ---------- */
  $$('[data-n-acc-row]').forEach((row) => {
    const data = JSON.parse($('[data-n-acc-json]', row).textContent);
    const priceEl = $('[data-n-acc-price]', row);
    const btn = $('[data-n-acc-add]', row);
    const current = () => {
      const sel = $$('[data-n-acc-opt]', row).sort((a, b) => a.dataset.nAccOpt - b.dataset.nAccOpt).map((s) => s.value);
      return sel.length ? findVariant(data.variants, sel) : data.variants[0];
    };
    const paint = () => {
      const v = current();
      if (priceEl && v) priceEl.textContent = money(v.price);
      btn.disabled = !v || !v.available;
      btn.title = !v ? 'Unavailable' : v.available ? '' : 'Sold out';
    };
    row.addEventListener('change', paint);
    btn.addEventListener('click', async () => {
      const v = current();
      if (!v || !v.available) { toast('This option is not available.'); return; }
      btn.classList.add('is-loading');
      try {
        await addToCart([{ id: v.id, quantity: 1 }]);
        btn.classList.add('is-done');
        toast('Added to your cart ✓');
        setTimeout(() => btn.classList.remove('is-done'), 1600);
      } catch (err) { toast(err.message); }
      finally { btn.classList.remove('is-loading'); }
    });
    paint();
  });

  /* ---------- Variant pickers inside cart accessory cards (re-rendered, so delegated) ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-n-vf-opt]');
    if (!sel) return;
    const f = sel.closest('[data-n-variant-form]');
    const data = JSON.parse($('[data-n-vf-json]', f).textContent);
    const opts = $$('[data-n-vf-opt]', f).sort((a, b) => a.dataset.nVfOpt - b.dataset.nVfOpt).map((s) => s.value);
    const v = findVariant(data, opts);
    const id = $('[data-n-vf-id]', f), price = $('[data-n-vf-price]', f), btn = $('button[type=submit]', f);
    if (v) { id.value = v.id; if (price) price.textContent = money(v.price); }
    if (btn) { btn.disabled = !v || !v.available; btn.textContent = !v ? 'N/A' : v.available ? 'Add' : 'Sold out'; }
  });

  /* ---------- Order tracking (17TRACK public widget) ---------- */
  $$('[data-n-track]').forEach((root) => {
    const form = $('[data-n-track-form]', root);
    const input = $('[data-n-track-input]', root);
    const err = $('[data-n-track-error]', root);
    const out = $('[data-n-track-result]', root);
    let loading = null;
    const load = () => loading || (loading = new Promise((res, rej) => {
      if (window.YQV5) { res(); return; }
      const s = document.createElement('script');
      s.src = 'https://www.17track.net/externalcall.js';
      s.async = true;
      s.onload = () => (window.YQV5 ? res() : rej(new Error('unavailable')));
      s.onerror = () => rej(new Error('unavailable'));
      document.head.appendChild(s);
      setTimeout(() => rej(new Error('timeout')), 12000);
    }));
    const fail = (m) => { err.textContent = m; err.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); };
    const params = new URLSearchParams(location.search);
    if (params.get('tracking')) input.value = params.get('tracking');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      err.hidden = true; input.removeAttribute('aria-invalid');
      const num = (input.value || '').replace(/\s+/g, '').toUpperCase();
      if (!num) { fail('Please enter your tracking number.'); return; }
      if (/^#?\d{3,6}$/.test(input.value.trim())) { fail('This looks like an order number. Please use the tracking number from your shipping email.'); return; }
      if (!/^[A-Z0-9-]{8,40}$/.test(num)) { fail('That doesn’t look like a tracking number. It is usually 8–40 letters and numbers — check your shipping confirmation email.'); return; }
      out.innerHTML = '<p class="small muted">Looking up your parcel…</p>';
      try {
        await load();
        out.innerHTML = '';
        window.YQV5.trackSingle({ YQ_ContainerId: 'YQContainer', YQ_Height: 600, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
        const url = new URL(location.href); url.searchParams.set('tracking', num); history.replaceState({}, '', url);
      } catch (x) {
        out.innerHTML = '';
        fail('The tracking service could not be reached right now. Please try again in a moment, or use the tracking link in your shipping email.');
      }
    });
  });
})();
